import type { IconDefinition } from '../index.tsx';

export const iconAddPlayer: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAddPlayer',
  icon: [
    16,
    16,
    [],
    '',
    'M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6ZM11.0232 8.78487C11.1216 8.33599 11.5216 8 12 8C12.5523 8 13 8.44771 13 9V11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14V13H9C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11H11V9C11 8.92615 11.008 8.85417 11.0232 8.78487ZM9 9C9 8.65112 9.05956 8.31614 9.16906 8.00468C9.1131 8.00158 9.05673 8 9 8H3C1.34315 8 0 9.34315 0 11V14H6.76389C6.28885 13.4692 6 12.7684 6 12C6 10.3431 7.34315 9 9 9Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
